<ng-container *ngIf="componentData$ | async as data">
  <cx-generic-link
    *ngIf="data.url !== '/bike/nl/nl/login'; else seuLogin"
    [ngClass]="styleClass"
    [url]="data.url"
    [style]="data.styleAttributes"
    >{{ data.linkName }}</cx-generic-link
  >
  <ng-template #seuLogin>
    <a role="link" [href]="data.url">{{ data.linkName }}</a>
  </ng-template>
</ng-container>
